<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="dataWithExactMatches"
      :tableTitle="'Locations'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  import API from '../../../../api/endpoints'
  export default {
    name: 'LocationSearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    computed: {
      defaultReqBody () {
        return !this.isFullSearch ? this.query['quick-search'] : JSON.parse(this.query['search'])
      },
      reqBody () {
        return !this.isFullSearch ? this.query['quick-search'] : this.strippedForCountry
      },
      fullSearchBody () {
        return JSON.parse(this.query['search'])
      },
      strippedForCountry () {
        let obj = {}
        for (let prop in this.fullSearchBody) {
          if (prop === 'country' && this.fullSearchBody[prop]) {
            obj[prop] = '!%!' + this.fullSearchBody[prop] + '!%!'
          } else {
            obj[prop] = this.fullSearchBody[prop]
          }
        }
        return obj
      }
    },
    methods: {
      quickSearch (opts) {
        const url = API.GET_ADMIN_ENTITY_BY_QUICK_SEARCH(this.entityName, this.reqBody || '') + '&category=ALL'
        return this.$http.get(url, {
          headers: {
            'X-Lazy-Fetch': this.lazy || '1',
            'X-Order-By': this.orderBy,
            ...opts
          }
        })
      }
    },
    data () {
      return {
        fields: [
          { header: 'Name', prop: 'name' },
          { header: 'ZipCode', prop: 'postCode' },
          { header: 'State', prop: 'subdivision' },
          { header: 'Zone', prop: item => item.zone !== null && item.zone.hasOwnProperty('name') ? item.zone.name : '' },
          { header: 'Country', prop: item => item.country !== null && item.country.hasOwnProperty('name') ? item.country.name : '' }
        ],
        loading: false,
        tableData: [],
        entityName: 'location',
        editEntityScreen: 'Admin - Edit/View Location',
        shouldSearchForExactMatch: false,
        exactMatchesRequired: [
          {
            entityProp: 'country',
            relatedPropId: 'id'
          }
        ]
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Location/LocationSearchResults.vue